import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_36_0 = () => {
  return (
    <div>
      <PageTitle title='3.36.0' />

      <ParaTitle paraTitle='Report Enhancements' />
      <Paragraph paragraph='2024-12-03' />
      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          User management report
          <p>The ability to run a report of who has logged in to TSN and used the system.</p>
        </li>

      </ul>
      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Help desk notifications
          <p>Hook the TSN help desk feature to GitLab's Service Desk</p>
        </li>
        <li>Specific event summary
          <p>Update the exported CSV file name, including the report name and export date.</p>
          <p>Update the event name as abbreviation in the specific event report to prevent getting cut in too short in the legend.</p>
          <p>Update the word on TSN feedback report annotation.</p>
        </li>
        <li>Update to system health status view
          <p>Add the ability to evaluate an increase in safety event reporting over time, by individual hospital, groups of hospitals (such as critical access, psychiatric, and other facilities) and total for the whole PSO system.</p>
        </li>
      </ul>
      <Pagination
                pagination={{
                    prev: { name: 'Updates: 3.37.0', link: '/updates/3.37.0' },
                    next: { name: 'Events Summary', link: '/general/events-summary' }
                }}
            />
    </div>

  )
}

export default Updates_3_36_0;